// src/pages/AccountVerification.js
import React from "react";
import Logo from "./assets/Trafari_MainLogo1.png";
import Mascot from "./assets/Trafari_Mascot.png";
import './App.css';

export default function AccountVerification() {
  return (
    <div
      style={{
        backgroundColor: "#391a8a",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Lilita One', sans-serif",
        color: "white",
        textAlign: "center",
        padding: "2rem",
      }}
    >
      <img
        src={Logo}
        alt="Trafari Logo"
        style={{ width: "400px", marginBottom: "1.5rem" }}
      />
      <h1 style={{ fontSize: "3rem", marginBottom: "1rem" }}>
        Account Verified!
      </h1>
      <p style={{ fontSize: "2rem", marginBottom: "2rem" }}>
        You can now log into Trafari and find events near you!
      </p>
      <img
        src={Mascot}
        alt="Trafari Mascot"
        style={{ width: "100px", marginTop: "1rem" }}
      />
    </div>
  );
}
